<template>
  <md-field>
    <label>Year Season</label>
    <md-select
      v-bind:value="value"
      v-on:input="$listeners['input']"
      v-bind="$attrs"
    >
      <md-option v-for="type in types" :key="type.id" :value="type.id">{{
        type.name
      }}</md-option>
    </md-select>
  </md-field>
</template>

<script>
import Api from "@/openapi/src/api/YearSeasonApi.js";

export default {
  name: "YearSeasonSelect",
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      types: []
    };
  },
  created() {
    new Api().getYearSeasons(this.$root.hotelId, (error, data, response) => {
      this.types = data;
    });
  }
};
</script>
